import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { space, typography, layout } from "styled-system";
import propTypes from "@styled-system/prop-types";
import themeGet from "@styled-system/theme-get";
import Link from "../../../hoc/Link";
import Scrollbar from "../scrollbar";
import { BadgeStyle } from "../badge/badge.style";

const SidebarStyle = styled("div", {
  fixed: PropTypes.bool,
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-shrink: 0;
  min-height: 56px;
  background: ${themeGet("colors.header.backgroundColor", "#fff")};
  border-bottom: 1px solid ${themeGet("colors.header.borderColor", "#d8dbe0")};
  
  ${({ fixed }) => fixed && css`
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1029;
  `}
  
  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const SidebarNavStyle = styled(Scrollbar, {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  
  &.ps {
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const SidebarNavItemStyle = styled("li", {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  width: inherit;

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const SidebarNavLinkStyle = styled(Link, {
  disabled: PropTypes.bool,
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0.8445rem 1rem;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.3s, color 0.3s;
  color: rgba(0, 0, 21, 0.8);
  background: transparent;

  &[aria-current] {
    color: ${themeGet("colors.sidebarNavLink.colorActive", "#1b4aa8")};
    cursor: default;
  }
  
  ${BadgeStyle} {
    margin-left: auto;
  }
  
  ${({ disabled }) => disabled && css`
    cursor: default;
  `}

  @media (hover: hover), (-ms-high-contrast: none) {
    &:hover {
      text-decoration: none;
    }
  }
  
  ${SidebarStyle} & {
    color: rgba(255, 255, 255, 0.8);
    background: transparent;

    &[aria-current] {
      color: ${themeGet("colors.sidebarNavLink.colorActive", "#1b4aa8")};
      background: rgba(0, 0, 21, 0.05);
    }
    
    &:focus {
      outline: none;
    }

    @media (hover: hover), (-ms-high-contrast: none) {
      &:hover {
        color: #fff;
        background: #321fdb;
      }
    }

    ${({ disabled }) => disabled && css`
      color: #b3b3b3;
      background: transparent;
      
      &:hover {
        color: #b3b3b3;
      }
    `}
  }

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const SidebarNavDividerStyle = styled("li", {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  height: 10px;
  transition: height 0.3s;
  border-bottom: 1px solid rgb(221, 221, 221);
  margin-bottom: 10px;

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

export {
  SidebarStyle,
  SidebarNavStyle,
  SidebarNavItemStyle,
  SidebarNavLinkStyle,
  SidebarNavDividerStyle,
};
